import { render, staticRenderFns } from "./keynote.vue?vue&type=template&id=560f9db2&scoped=true&"
import script from "./keynote.vue?vue&type=script&lang=js&"
export * from "./keynote.vue?vue&type=script&lang=js&"
import style0 from "./keynote.vue?vue&type=style&index=0&id=560f9db2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f9db2",
  null
  
)

export default component.exports